<template>
  <v-menu
    offset-y
    left
    nudge-bottom="14"
    min-width="230"
    content-class="user-profile-menu-content"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-avatar class="ms-4" size="40px" v-bind="attrs" v-on="on">
        <v-img :src="pictureUrl" :lazy-src="pictureLoadUrl"></v-img>
      </v-avatar>
    </template>
    <v-list>
      <div class="pb-3 pt-2">
        <v-avatar size="40px" class="ms-4">
          <v-img :src="pictureUrl" :lazy-src="pictureLoadUrl"></v-img>
        </v-avatar>
        <div
          class="d-inline-flex flex-column justify-center ms-3"
          style="vertical-align: middle"
        >
          <span class="text--primary font-weight-semibold mb-n1">
            {{ displayName }}
          </span>
        </div>
      </div>

      <template v-if="signedin">
        <v-divider></v-divider>

        <v-list-item v-if="profilePageUrl" link :href="profilePageUrl">
          <v-list-item-icon class="mr-4">
            <v-icon size="22"> mdi-account-outline </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ profile }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="my-2"></v-divider>

        <v-list-item v-if="signedin" link @click="signout">
          <v-list-item-icon class="mr-4">
            <v-icon size="22"> mdi-logout-variant </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ logoff }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-list-item v-else link to="/signin">
        <v-list-item-icon class="mr-4">
          <v-icon size="22"> mdi-login-variant </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ login }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
  
  <script>
import { mapState } from "pinia";
import { useLocalStore } from "../../../store/local";
import { useUserStore } from "../../../store/user";

export default {
  name: "UserMenu",

  data() {
    return {
      pictureLoadUrl: require("../../../assets/img/guest.png"),
    };
  },

  computed: {
    ...mapState(useUserStore, [
      "displayName",
      "signedin",
      "pictureUrl",
      "profilePageUrl",
    ]),
    ...mapState(useLocalStore, ["profile", "logoff", "login"]),
  },

  methods: {
    async signout() {
      const userStore = useUserStore();
      await userStore.signout();
    },
  },
};
</script>
  
  <style lang="scss">
.user-profile-menu-content {
  .v-list-item {
    min-height: 2.5rem !important;
  }
}
</style>
  